module.exports = __webpack_public_path__ + "img/bg-banner.5d928871.png";